module.exports = "/packs/thumbnail_trial_lesson-8ae36095fa92dc6086b0c342c0ae8775.jpg";